import React , { Component } from 'react';
import $ from 'jquery';
import {browserHistory, Link} from 'react-router';
import {Image,Breadcrumb,Modal} from 'react-bootstrap';
import Geosuggest from 'react-geosuggest';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';


export default class Web_Profile extends Component {
  constructor(props){
    super(props);
    this.state={
        pro_pic: baseAssets+'images/pro_pics/web_default_img.png',
        full_details: [],
        name: '',
        mobile: '',
        email: '',
        door_no:'',
        city:'',
        file:'',
        imageUrl: '',
        otp_flag: '',
        email_flag: '',
        editName_status: false,
        editEmail_status: false,
        editDoorNo_status: false,
        err_name: '',
        err_name_status: false,
        err_email_status: false,
        err_email: '',
        err_door_no_status: false,
        err_door_no: '',
        editCityAddress_status: false,
        err_cityAddress_status: false,
        err_cityAddress: '',

        pincode:'',
        err_pincode_status:false,
        err_pincode_msg:'Invalid pincode',
        page_loading:false,

        delimg_status:false,
    };
    this.getPhoto=this.getPhoto.bind(this);
    this.uploadFile=this.uploadFile.bind(this);
    this.editName=this.editName.bind(this);
    this.NameChange=this.NameChange.bind(this);
    this.EmailChange=this.EmailChange.bind(this);
    this.editEmail=this.editEmail.bind(this);
    this.editDoorNo=this.editDoorNo.bind(this);
    this.DoorNoChange=this.DoorNoChange.bind(this);
    this.saveChanges=this.saveChanges.bind(this);
    this.submitProfileData=this.submitProfileData.bind(this);
    this.editCityAddress=this.editCityAddress.bind(this);
    this.onSuggestSelect=this.onSuggestSelect.bind(this);
    this.pincodeChange=this.pincodeChange.bind(this);
    
    this.getProfileDetails =this.getProfileDetails.bind(this);
    this.removeProfilePic =this.removeProfilePic.bind(this); 
    this.close =this.close.bind(this);
  }
  componentDidMount()
  {
    if(screen.width < 800)
    {
      window.location.href="/profile";
    }
    localStorage.removeItem('w_r_s_dt');
    localStorage.removeItem('w_r_e_coupon_dt');
    localStorage.removeItem('w_r_e_s_dt');
    localStorage.removeItem('web_mycart');
    localStorage.removeItem('w_r_enq_seller_page');
    localStorage.removeItem('w_r_p_dt');
    localStorage.removeItem('w_r_e_p_dt');
    localStorage.removeItem('web_ofr_page');
    localStorage.removeItem('myaquacash');
    localStorage.removeItem('web_share_earn');
    localStorage.removeItem('checkout');
    localStorage.removeItem('order_details');
    localStorage.removeItem('myorders');
    localStorage.removeItem('w_r_p_deals');
    localStorage.removeItem('seed');
    localStorage.removeItem('nauplii');
    localStorage.removeItem('subdeals');
    localStorage.removeItem('shipping');
    localStorage.removeItem('notifications');
    localStorage.removeItem('web_quickcart');
    localStorage.removeItem('view_rating');
    localStorage.removeItem('w_modal_seed');
    localStorage.removeItem('w_r_seed_deals');
    localStorage.removeItem('w_r_e_p_dt');
    localStorage.removeItem('w_modal_details');
    localStorage.removeItem('offers');
    localStorage.removeItem('give_rating');
    localStorage.removeItem('pprice');
    localStorage.removeItem('sprice');
    localStorage.removeItem('seed_id');
    localStorage.removeItem('h_type');
    localStorage.removeItem('web_pro_ofr_dtls');
    localStorage.removeItem('web_wishlist');
    localStorage.removeItem('web_brand_details');

    localStorage.removeItem('m_r_s_dt');
    localStorage.removeItem('m_r_e_coupon_dt');
    localStorage.removeItem('m_r_e_s_dt');
    localStorage.removeItem('mob_mycart');
    localStorage.removeItem('m_r_enq_seller_page');
    localStorage.removeItem('m_r_p_dt');
    localStorage.removeItem('m_r_e_p_dt');
    localStorage.removeItem('ofr_page');
    localStorage.removeItem('pro_ofr_dtls');

    localStorage.removeItem('share_earn');
    localStorage.removeItem('my_orders');
    localStorage.removeItem('m_r_p_deals');
    localStorage.removeItem('mob_quickcart');
    localStorage.removeItem('partner_deals'); 

    
    if(!localStorage.token && !localStorage.user_id)
    {
        localStorage.setItem('profile','/web/profile');
        browserHistory.push('/web/login');
    }
    else
    {
        this.getProfileDetails();
    }
  }
  getProfileDetails()
  {
      var data1={from:'desktop_web',uid:localStorage.getItem('user_id'),token: localStorage.getItem('token'),device_id:localStorage.getItem('push_device_id')};
      var data2=JSON.stringify(data1);
      $.ajax({
          method:'POST',
          url:baseUrl+'myprofile',
          dataType:'json',
          data: {req: data2},
          success: function(data)
          {
            if(data.msg==='success')
            {
              this.setState({
                  full_details: data.details,
                  pro_pic: baseAssets+'images/pro_pics/'+data.details[0].pro_pic,
                  name: data.details[0].name,
                  mobile: data.details[0].mobile,
                  email:data.details[0].email,
                  door_no: data.details[0].address1,
                  city:data.details[0].city,
                  otp_flag: data.details[0].otp_flag,
                  email_flag:data.details[0].email_flag,
                  pincode:data.details[0].zip,
              });
              localStorage.setItem('mobile_number',data.details[0].mobile);
            }
            if(data.status ==='error' && data.message ==='Token mismatch')
            {
              localStorage.removeItem('token');
              localStorage.removeItem('user_id');
              localStorage.setItem('profile','/web/profile');
              browserHistory.push('/web/login')
            }
            
          }.bind(this),
          error: function(err)
          {
          }
      });
  }
  removeProfilePic()
  {
    if(localStorage.user_id)
    {
      var uid =localStorage.user_id;
    }
    else
    {
       uid=0;
    }
    var data1={from:'desktop_web',id:uid,token:localStorage.token};
    var data2=JSON.stringify(data1);
    $.ajax({
       url:baseUrl+'removePropic',
       method:'POST',
       dataType:'JSON',
       data:{req:data2},
       success:function(data)
       {
        if(data.status==='success')
            {
              this.setState({
                delimg_status:false,
                // page_loading:false,
              });
              // window.location.reload();
              this.getProfileDetails();

            }
            if(data.status==='error' && data.message==='Token mismatch')
            {
              this.setState({
                  // page_loading:false,
              })
              this.tokenCheck();
            }
       }.bind(this),
       error:function(err)
       {

       }

    });
  }
  pincodeChange()
  {
      // alert(this.refs.pincode.value);
      var invalidChars = /[^0-9]/gi;
      if(invalidChars.test(this.refs.pincode.value)) 
      {
          var x = this.refs.pincode.value.replace(invalidChars,"");
      }
      else
      {
          this.setState({
            err_pincode_status: true,
          });
      }
      this.setState({
          pincode:x,
          err_pincode_status:false,
      });
      // this.setState({
      //     pincode:this.refs.pincode.value,
      //     err_pincode:false,
      // });
      

      // var invalidChars = /[^0-9]/gi;
      // if(invalidChars.test(this.refs.pincode.value)) 
      // {
      //     var x = this.refs.pincode.value.replace(invalidChars,"");
      // }
      // else
      // {
      //     this.setState({
      //       err_pincode: true,
      //     });
      // }
      //   this.setState({
      //     pincode:x,
      //     err_pincode:false,
      //   });
  }
  getPhoto(e)
  {
    e.preventDefault();
    let reader= new FileReader();
    let file= e.target.files[0];
    reader.onloadend= () => {
      this.setState({
          file: file,
          imageUrl: reader.result,
      })
    };
    reader.readAsDataURL(file);
    this.setState({
      page_loading:true,
    });
    setTimeout(() => {this.uploadFile()}, 5000);
  }
  uploadFile(reader)
  {
    var data1={from:'desktop_web',uid: localStorage.getItem('user_id'),image:this.state.imageUrl};
    var data2=JSON.stringify(data1);    
    $.ajax({
        method: 'POST',
        url: baseUrl+'uploadImage',
        dataType:'json',
        data: {req:data2},
        success: function(data)
        {
          if(data.msg ==='success')
          {
            this.getProfileDetails();
            this.setState({
              page_loading:false,
            });
            // window.location.reload();
          }
        }.bind(this),
        error: function(err)
        {
        }
    });
  }
  editName(e)
  {
    this.setState({
        editName_status: true,
        err_name_status: false,
    });
  }
  NameChange(e)
  {
    this.setState({
      name: this.refs.e_name.value,
    });
  }
  editEmail(e)
  {
    this.setState({
        editEmail_status: true,
        err_email_status: false,
    });
  }
  EmailChange(e)
  {
    this.setState({
      email: this.refs.e_email.value,
    });
  }
  editDoorNo(e)
  {
    this.setState({
        editDoorNo_status: true,
        err_door_no_status: false,
    });
  }
  DoorNoChange(e)
  {
    this.setState({
      door_no: this.refs.e_door_no.value,
    })
  }
  editCityAddress(e)
  {
    this.setState({
      editCityAddress_status: true,
      err_cityAddress_status: false,
    });
  }
  onSuggestSelect(e)
  {
    this.setState({
      city: e.label,
    });
  }
  saveChanges(e)
  {
      this.setState({
          page_loading:true,
      });
      if(this.state.name.length < 3)
      {
        this.setState({
            err_name_status: true,
            err_name: 'Minimum 3 Characters',
        });
      }
      else
      {
        this.setState({
            err_name_status: false,
            err_name: '',
        });
        var s_name=this.state.name;
      }
      // if(this.state.pincode.length < 6)
      // {
      //     this.setState({
      //       err_pincode_status: true,
      //       err_pincode_msg:'Invalid pincode',
      //     });
      // }
      if(this.state.email.length > 0)
      {
        const emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
        if(!emailPattern.test(this.state.email))
        {
          var s_email='';
          this.setState({
            err_email_status: true,
            err_email: 'Invalid Email Address',
          });
        }
        else
        {
          this.setState({
              err_email_status: false,
              err_email: '',
          });
           s_email=this.state.email;
        }
      }
      else
      {
         s_email='';
      }
      // if(this.state.door_no.length < 1)
      // {
      //   // alert("Enter Door No");
      //   this.setState({
      //       err_door_no_status: true,
      //       err_door_no: 'Enter Door No',
      //   });
      // }
      // else
      // {
      //   // alert("Door No good");
      //   this.setState({
      //       err_door_no_status: false,
      //       err_door_no: '',
      //   });
      //   var s_door_no=this.state.door_no;
      // }
      if(s_name && !this.state.err_email_status)
      {
        // this.submitProfileData(s_name,s_email,s_door_no,)
        setTimeout(() => {this.submitProfileData(s_name,s_email)}, 3000);
      }
      else
      {
        alert('Please fill the details');
      }
  }
  close()
  {
    this.setState({delimg_status:false});
  }
  submitProfileData(s_name,s_email,s_door_no)
  {
        var data1={from:'desktop_web',uid: localStorage.getItem('user_id'),name: s_name,email: s_email, add1:'',city: this.state.city,dist: '',state: '', zip: this.refs.pincode.value }
        var data2=JSON.stringify(data1);
        if(!this.state.err_email_status)
        {
            $.ajax({
                method: 'POST',
                url: baseUrl+'myprofile_save',
                dataType:'json',
                data: {req: data2},
                success: function(data)
                {
                    if(data.status==="success")
                    {
                      browserHistory.push('/web/home');
                    }
                    else
                    {
                      this.setState({
                          page_loading:false,
                      });
                    }
                }.bind(this),
                error: function(err){
                  // console.log(err);
                }
            });  
        }
        else
        {
          console.log('Please fill the details');
        }
  }
  render()
  {
      $('#profile_email').unbind("keyup").keyup(function(){
          $('.email_verify').hide();
      });         
      document.title="My Profile | AquaDeals";
      var fixtures = [
          {label: 'Kakinada, Andhra Pradesh, India', location: {lat: 16.9890648, lng: 82.24746479999999}},
          {label: 'Bhimavaram, Andhra Pradesh, India', location: {lat: 16.544893, lng: 81.52124100000003}},
          {label: 'Samalkota, Andhra Pradesh, India', location: {lat: 17.0504374, lng: 82.16592430000003}},
          {label: 'Amalapuram, Andhra Pradesh, India',location: {lat: 16.5720904, lng: 82.00085480000007}}
      ];
       return (
       <div className="web_Deals web_profile_page">
          <WebHeaderInner image={this.state.pro_pic}/>
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          <div className="clr">&nbsp;</div>
          <div className='container'>
             <Breadcrumb className="webmyprofile_breadcrmb">
                <Breadcrumb.Item href="/web/home" >Home</Breadcrumb.Item>
                <Breadcrumb.Item active>My Profile</Breadcrumb.Item>
             </Breadcrumb>
          </div>
          <section className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12 webDels_cntnt" style={{paddingLeft:'0',paddingRight:'0'}}>
  
                  <section className="web_pro_img_blk">
                      <form action='' encType="multipart/form-data">
                         {this.state.pro_pic===baseAssets+'images/pro_pics/web_default_img.png' ? 
                          <label for="image_edit" className="web_Edit_pro_Img">
                                <input type="file" name="image_edit" id="image_edit" style={{display:'none'}} onChange={this.getPhoto} />
                                <Image src={'https://aquadeals.in/admin/assets/images/web_imgs/came_icon.png'} alt="" className="web_Edit_Pro" style={{marginTop:'5px'}} />
                          </label>
                          :
                          <label for="del_img" className="web_delimg" onClick={()=>{this.setState({delimg_status:true})}}>
                              <Image src={'https://aquadeals.in/admin/assets/mob-assets/cam_remove_pic.png'} alt="" className="web_Edit_Pro" style={{marginTop:'5px'}} />
                          </label>
                          }
                      </form>
                      <div className="web_pro_img_blk web_Side_Bar_Prfil">
                           <form action='' encType="multipart/form-data">
                            <div className="web_Pro_Img web_Side_Bar_Prfil_Pic">
                                <label for="image">
                                  <input type="file" name="image" id="image" style={{display:'none'}} onChange={this.getPhoto} />
                                  <span className="web_pro_inner_icon"><Image src={this.state.pro_pic} alt="" circle  /></span>
                                </label>
                            </div>
                          </form>
                      </div>
                  </section>
                  <div className="clr">&nbsp;</div>
                  <div className="row">
                     <div className="col-sm-6 col-lg-6 col-md-6 col-md-offset-6 pro_btns" >
                        <div className="col-md-12 col-lg-12 col-sm-12">
                          <div className="col-md-6 col-lg-6 ">
                            <Link to={"/web/change_number"} className="btn btn-default btn-lg mobile_change"><i style={{paddingRight:'5px'}}><img src={'https://aquadeals.in/admin/assets/images/web_imgs/mobile_number.png'} alt=" " width="20px" /></i>CHANGE MOBILE NUMBER</Link>
                          </div>
                          <div className="col-md-6 col-lg-6">
                            <Link to={'/web/reset'} className="btn btn-lg btn-default reset_pass"><i style={{paddingRight:'7px'}}><img src={'https://aquadeals.in/admin/assets/images/web_imgs/password.png'} width="20px" alt=""/></i>RESET PASSWORD </Link>
                          </div> 
                        </div>
                     </div>
                  </div>
                   <div className="clr">&nbsp;</div>
                   <div className="clr">&nbsp;</div>
                   <div className="clr">&nbsp;</div>
                  <div className="row">
                     <div className="col-md-4 col-lg-4 col-sm-4"> 
                       <div className="webPro_Dtls_Blk">
                          <h4 className="web_per_Info_Title">Personal Information <i  onClick={this.editName} className="glyphicon glyphicon-pencil profile_edit_sym"></i></h4>
                          <div className="web_psl_Info_Blk">
                              <h5 onClick={this.editName}>{this.state.name && !this.state.editName_status ? <p className="input_name">{this.state.name}</p> : <input type="text" ref="e_name" placeholder="Name" value={this.state.name} onChange={this.NameChange} style={{border:'none',textDecoration:'underline',width:'100%',outline:'none' }}  />}<span style={{color:'red',fontSize:'12px'}} > {this.state.err_name_status ? this.state.err_name : ''}</span></h5>
                              <h5 className='col-md-12 col-lg-12 col-sm-12'>
                               {this.state.mobile ? <p className="col-md-6 col-sm-6 col-lg-6 input_mobile">{this.state.mobile}</p> : 'Mobile'} 
                               {this.state.otp_flag ==='1' ? <p className="col-md-6 col-sm-6 col-lg-6 pro_num_Status_Img text-right"><img src={baseAssets+'mob-assets/ok.png'} alt="" /></p> : <p className="col-md-6 pro_num_status">&nbsp;</p>}</h5>
                              <h5 className='col-md-12 col-lg-12 col-sm-12' onClick={this.editEmail}>{this.state.email  && !this.state.editEmail_status ?<p className="input_email col-sm-6 col-md-6">{this.state.email}</p>:<p className="input_email col-sm-6 col-md-6"><input type="mail" ref="e_email" placeholder="Email(Optional)" value={this.state.email} onChange={this.EmailChange} id="profile_email" /></p>}{(this.state.email_flag==='1' && this.state.email !='') ? <p className="col-sm-6 col-md-6 pro_num_Status_Img text-right"><img src={baseAssets+'mob-assets/ok.png'} alt="" /></p> :<p className="pro_num_status col-sm-6 col-md-6">&nbsp;</p> }<p style={{color:'red',fontSize:'12px'}}>{this.state.err_email_status ? this.state.err_email : ''}</p><p className="web_email_verify">{(this.state.email_flag == 0 && this.state.email !='') ? 'Not verified' : ''}</p></h5>
                          </div>
                       </div>
                     </div>
                      <div className="col-lg-8  col-md-8 col-sm-8" > 
                           {this.state.page_loading ? <i className="web_Pro_Load_Img text-left"><img src={baseAssets+'images/loading_more.gif'} alt="Loading" /></i> : ''}
                      </div>
                  </div>
                  <hr className="webprofile_hr" /> 
                  <div className="">
                     <div className="col-md-4 col-sm-4 col-lg-4">                         
                          <h4 className="web_Cnt_Info_Title">Contact Information</h4>
                          <div className="web_Cnt_Info">
                             {/* <h5 onClick={this.editDoorNo} style={{paddingLeft:'15px'}}>{this.state.door_no && !this.state.editDoorNo_status ? this.state.door_no : <input type="text" ref="e_door_no" value={this.state.door_no} placeholder="Door no / Landmark" onChange={this.DoorNoChange} style={{border:'none',textDecoration:'underline',width:'100%'}} /> }<span style={{color:'red',fontSize:'12px'}}>{this.state.err_door_no_status ? this.state.err_door_no : ''}</span></h5> */}
                              <h5 onClick={this.editCityAddress} style={{fontSize:'12px'}}>{this.state.city && !this.state.editCityAddress_status ? this.state.city : <Geosuggest fixtures={fixtures} placeholder="Select Address" onSuggestSelect={this.onSuggestSelect} ignoreTab={true} />}</h5>
                              <h5>
                                <input type="text" ref="pincode" placeholder="Pincode" value={this.state.pincode==='0' ? '' : this.state.pincode}  onChange={this.pincodeChange} style={{border:'none',width:'100%',outline:'none'}} maxLength={6} />
                                {this.state.err_pincode_status ? <p>{this.state.err_pincode_msg}</p> : ''}
                              </h5>
                          </div>
                     </div>
                     <div className="col-md-8 col-lg-8 col-sm-8">&nbsp;</div>     
                  </div> 
                    <div className="clr">&nbsp;</div>
                    <div className="web_profile_Save_Btn text-center" onClick={this.saveChanges}>Save</div>
                    <div className="clr">&nbsp;</div>
              </div>
           </div>
             <Modal show={this.state.delimg_status} onHide={this.close}>
                <Modal.Body>
                   <p>Want to remove profile photo?</p>
                </Modal.Body>
                <Modal.Footer>
                   <div className="webdelimg_btns"> 
                    <a className="Nobtn" onClick={this.close}>NO</a>
                    <a onClick={()=>{this.removeProfilePic()}}>YES</a>
                   </div>
                </Modal.Footer>

             </Modal>     
          </section>
          <WebFooter /> 
      </div>
     );
  }
}



/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Accounts/Web_Profile.js
 **/